import $ from 'jquery';

import './JobList.scss';
import template from './JobList.vhtml';

export default {
	name: 'JobList',
	template: template,
	props: ['category'],
	data: () => ({
		jobs: [],
		isLoading: false,
	}),
	watch: {
		category() {
			this.reload();
		},
	},
	methods: {
		reload() {
			this.isLoading = true;
			this.jobs = [];
			getJobs(this.category || 'all')
				.then(res => {
					if (res) {
						if (typeof res != 'object') {
							res = JSON.parse(res)
						}
						this.jobs = res;
					}
				})
				.always(() => {
					this.isLoading = false;
				});
		}
	},
	created: function () {
		this.reload();
	}
};

function getJobs(category) {
	const params = {
		category,
		'_': '1.5',
	};

	return $.get('/wp-json/be/v1/jobs', params);
}
